<template>
  <div class="retrievePw sw-container">
    <div class="common-nav">
      <span class="s1">您的位置</span>
      <span class="s2">|</span>
      <span class="s3">找回密码</span>
    </div>
    <div class="retrievePw-main">
      <div class="retrievePw-steps">
        <div
          class="retrievePw-steps-item"
          :class="{
            'retrievePw-steps-active': nav == 0,
            'retrievePw-steps-ok': nav > 0,
          }"
        >
          <span class="s1"></span>
          <span class="s2">输入登录名</span>
        </div>
        <div class="retrievePw-steps-line"></div>
        <div
          class="retrievePw-steps-item"
          :class="{
            'retrievePw-steps-active': nav == 1,
            'retrievePw-steps-ok': nav > 1,
          }"
        >
          <span class="s1"></span>
          <span class="s2">验证身份</span>
        </div>
        <div class="retrievePw-steps-line"></div>
        <div
          class="retrievePw-steps-item"
          :class="{
            'retrievePw-steps-active': nav == 2,
            'retrievePw-steps-ok': nav > 2,
          }"
        >
          <span class="s1"></span>
          <span class="s2">新密码输入</span>
        </div>
        <div class="retrievePw-steps-line"></div>
        <div
          class="retrievePw-steps-item"
          :class="{
            'retrievePw-steps-active': nav == 3,
            'retrievePw-steps-ok': nav > 3,
          }"
        >
          <span class="s1"></span>
          <span class="s2">完成</span>
        </div>
      </div>
      <div class="retrievePw-page" v-if="nav == 0">
        <div class="retrievePw-box">
          <span class="retrievePw-box-label">登录名</span>
          <Input
            v-model="userName"
            placeholder="请输入身份证号"
            style="width: 400px"
          />
        </div>
        <div class="retrievePw-box">
          <span class="retrievePw-box-label">验证码</span>
          <Input
            v-model="code"
            placeholder="请输入右图验证码"
            style="width: 200px"
          />
          <img
            class="retrievePw-box-codeImg"
            @click="refreshImgCode"
            :src="codeSrc"
          />
          <span class="retrievePw-box-codeBtn" @click="refreshImgCode"
            >看不清?下一张</span
          >
        </div>
        <div class="retrievePw-box">
          <span class="retrievePw-box-label"></span>
          <div class="retrievePw-box-btn" @click="submit">确认</div>
        </div>
      </div>
      <div class="retrievePw-page" v-if="nav == 1">
        <div class="retrievePw-box">
          <span class="retrievePw-box-label">已验证手机</span>
          <span class="retrievePw-box-test">{{ phone | cPhone }}</span>
        </div>
        <div class="retrievePw-box">
          <span class="retrievePw-box-label">验证码</span>
          <Input
            v-model="code2"
            placeholder="请输入收到的验证码"
            style="width: 320px"
          />
          <span class="retrievePw-box-codeBtn2" @click="getCode">{{
            codeTest
          }}</span>
        </div>
        <div class="retrievePw-box">
          <span class="retrievePw-box-label"></span>
          <div class="retrievePw-box-btn" @click="submit">确认</div>
        </div>
      </div>
      <div class="retrievePw-page" v-if="nav == 2">
        <div class="retrievePw-box">
          <span class="retrievePw-box-label">输入新密码</span>
          <Input
            v-model="pw"
            type="password"
            placeholder="请输入新密码"
            style="width: 400px"
          />
        </div>
        <div class="retrievePw-box">
          <span class="retrievePw-box-label">确认密码</span>
          <Input
            v-model="pw2"
            type="password"
            placeholder="确认密码"
            style="width: 400px"
          />
        </div>
        <div class="retrievePw-box">
          <span class="retrievePw-box-label"></span>
          <div class="retrievePw-box-btn" @click="submit">确认</div>
        </div>
      </div>
      <div class="retrievePw-page" style="margin: 0;" v-if="nav == 3">
        <img
          class="retrievePw-page-img"
          src="../../assets/img/approveSuc.png"
        />
        <p class="p1">已完成</p>
        <p class="p2">
          {{ timeNum }}S后自动跳转到<span @click="goHome">首页</span>
        </p>
      </div>
    </div>
    <Modal
      v-model="isShowModal"
      footer-hide
      :closable="false"
      width="600"
      class-name="vertical-center-modal"
    >
      <div class="modal">
        <img
          class="closeIcon"
          @click="isShowModal = false"
          src="../../assets/img/close.png"
        />
        <p
          slot="header"
          style="text-align:center;font-size: 18px;line-height:50px"
        >
          提示
        </p>
        <div
          style="text-align:center;font-size: 16px;height:120px;line-height:100px"
        >
          您未绑定过手机号码,请联系客服电话18187317894
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as api from "@/assets/api/api.js";
import {postDataJAVA} from "@/assets/api/api.js";
import {postDataJxjy} from "@/assets/api/api.js";
export default {
  name: "retrievePw",
  data() {
    return {
      isShowModal: false,
      userName: "",
      code: "",
      code2: "",
      nav: 0,
      codeTest: "点击发送",
      codeBtn: true,
      codeSrc: "",
      phone: "",
      timeNum: 5,
      pw: "",
      pw2: "",
    };
  },
  created() {
    api.EventBus.$emit("changeNav", -1);
    this.codeSrc = api.base + "student/captcha";
  },
  filters: {
    cPhone(val) {
      return val.slice(0, 3) + "*****" + val.slice(9, 11);
    },
  },
  beforeDestroy() {
    if (window.timer) {
      clearInterval(timer);
    }
  },
  methods: {
    //   更换验证码
    refreshImgCode() {
      this.codeSrc = this.codeSrc + "?" + Math.random();
    },
    submit() {
      if (this.nav == 0) {
        if (this.userName.length == 0) {
          this.$Message.error("请填写登录名");
          return;
        }
        if (this.code.length == 0) {
          this.$Message.error("请填写验证码");
          return;
        }
        let postData = {
          code: this.code,
        };
        postData.username = this.userName;
        api
          .postDataJAVA("/student/checkUserPhoneBind", postData, (err) => {
            if (err.data.message == "用户未绑定手机号") {
              // this.isShowModal = true;
			  this.$Message.warning("请先绑定手机号码");
			  this.$router.push({
			  	path: "/bindPhoneInfor",
			  });
              return;
            }
            this.$Message.error(err.data.message);
          })
          .then((res) => {
            this.phone = res.data;
            this.nav++;
          })
          .catch((res) => {});
      }
      if (this.nav == 1) {
        api
          .postData("student/checkSmsCode", {
            phone: this.phone,
            vercode: this.code2,
          })
          .then((res) => {
            this.nav++;
          })
          .catch((res) => {});
      }
      if (this.nav == 2) {
        if (this.pw.length == 0) {
          this.$Message.error("请填写密码");
          return;
        }
        if (this.pw2.length == 0) {
          this.$Message.error("请填写确认密码");
          return;
        }
        if (this.pw2 != this.pw) {
          this.$Message.error("两次密码不一致");
          return;
        }
        api
          .postData("student/updatePassword", {
            idcard: this.userName,
            password: this.pw,
          })
          .then((res) => {
            if (res.data) {
              this.nav++;
              window.timer = setInterval(() => {
                this.timeNum--;
                if (this.timeNum == 0) {
                  this.goHome();
                  clearInterval(timer);
                }
              }, 1000);
            }
          })
          .catch((res) => {});
      }
    },
    goHome() {
      this.$router.replace({
        path: "/",
      });
    },
    getCode() {
      if (!this.codeBtn) {
        return;
      }
      postDataJxjy("/jxjyapi/login/sendSmsCode", {
          phone: this.phone,
          type: 6,
        })
        .then((res) => {
          this.$Message.success("验证码发送成功");
        })
        .catch((res) => {
          clearInterval(timer);
          this.codeTest = "点击发送";
          this.codeBtn = true;
        });
      this.codeBtn = false;
      let num = 60;
      this.codeTest = num + "s";
      let timer = setInterval(() => {
        num--;
        if (num < 0) {
          clearInterval(timer);
          this.codeTest = "点击发送";
          this.codeBtn = true;
          return;
        }
        this.codeTest = num + "s";
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.closeIcon {
  cursor: pointer;
  position: absolute;
  top: -30px;
  right: -30px;
  height: 30px;
  width: 30px;
}
</style>
<style lang="scss">
.ivu-input {
  box-sizing: border-box;
  height: 36px;
  line-height: 36px;
}
.retrievePw {
  padding-bottom: 24px;
  &-main {
    height: 480px;
    background: #fff;
    padding-top: 82px;
  }
  &-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 92px;
    color: #222;
    &-item {
      display: flex;
      font-size: 14px;
      align-items: center;
    }
    .s1 {
      width: 14px;
      height: 14px;
      border: 1px solid rgba(34, 34, 34, 1);
      border-radius: 50%;
      margin-right: 8px;
    }
    &-line {
      width: 58px;
      height: 1px;
      background: #999999;
      margin: 0 12px;
    }
    &-active {
      color: #31af58;
      .s1 {
        border-color: #31af58;
        background: #31af58;
      }
    }
    &-ok {
      color: #999999;
      .s1 {
        border-color: #999999;
        background: #999999;
      }
    }
  }
  &-page {
    margin-left: 365px;
    &-img {
      width: 120px;
      display: block;
      margin: 0 auto;
    }
    .p1 {
      text-align: center;
      color: #222;
      font-size: 24px;
      margin: 30px 0 10px;
    }
    .p2 {
      text-align: center;
      color: #666666;
      font-size: 16px;
      span {
        color: #31af58;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  &-box {
    display: flex;
    align-items: center;
    color: #222222;
    font-size: 14px;
    margin-bottom: 20px;
    &-label {
      width: 70px;
      margin-right: 20px;
      text-align: right;
    }
    &-codeImg {
      margin-left: 20px;
      height: 32px;
      cursor: pointer;
      width: 64px;
    }
    &-codeBtn {
      cursor: pointer;
      color: #31af58;
      text-decoration: underline;
      margin-left: 12px;
    }
    &-codeBtn2 {
      width: 90px;
      height: 36px;
      background: rgba(248, 248, 248, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 3px;
      text-align: center;
      line-height: 36px;
      margin-left: 10px;
      color: #999;
      cursor: pointer;
    }
    &-codeBtn2:hover {
      background: rgba(248, 248, 248, 0.5);
    }
    &-btn {
      width: 120px;
      height: 40px;
      background: rgba(49, 175, 88, 1);
      cursor: pointer;
      border-radius: 4px;
      color: #fff;
      line-height: 40px;
      text-align: center;
    }
    &-btn:hover {
      background: rgba(49, 175, 88, 0.8);
    }
    &-test {
      color: #999;
    }
  }
}
</style>
